module.exports = __webpack_public_path__ + "static/copilot-web-macbook.e6a7c44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/copilot-web-macbook.png
// module id = ./src/pages/copilot-web-macbook.png
// module chunks = 100945961233241